export const  urlEncodeObject = obj => {

    const jsonString = JSON.stringify(obj);

    // 2. Convertir la chaîne JSON en tableau d'octets (Buffer en Node.js)
    const textEncoder = new TextEncoder();
    const jsonDataAsBytes = textEncoder.encode(jsonString);

    // 3. Convertir les octets en représentation hexadécimale
    function bytesToHex(bytes) {
        return Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');
    }

    return  bytesToHex(jsonDataAsBytes);


}

export const urlDecodeObject = hex => {
    // 1. Convertir la représentation hexadécimale en tableau d'octets
    function hexToBytes(hex) {
        const bytes = [];
        for (let i = 0; i < hex.length; i += 2) {
            bytes.push(parseInt(hex.substr(i, 2), 16));
        }
        return new Uint8Array(bytes); // Utilisez Uint8Array pour obtenir un tableau d'octets
    }

    const jsonDataAsBytes = hexToBytes(hex);

    // 2. Convertir le tableau d'octets en chaîne JSON
    const textDecoder = new TextDecoder();
    const jsonString = textDecoder.decode(jsonDataAsBytes);

    // 3. Parser la chaîne JSON en un objet JavaScript
    return JSON.parse(jsonString);


}





